module.exports = __webpack_public_path__ + "static/media/cloud1.d5f78f98.svg";